import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { BaseView } from '@/components/base'
import { StickyHeaderNavigation } from '@/components'
import {
  SetGoalAmountDisplay,
  SetGoalNumberPad,
  SetGoalButtonConfirmation,
  SetGoalConversionRelative,
} from '@/features/savings/set'
import { useSavingsStore } from '@/store/useSavingsStore'
import useOffsets from '@/hooks/useOffsets'

export default function SetGoalPage() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const offsets = useOffsets()

  const selectedGoal = useSavingsStore((state) => state.goal)

  // Check that goal is selected
  if (!selectedGoal.category) {
    navigate('/savings/select')
    return null
  }

  return (
    <BaseView
      flex={1}
      bgColor="background.screen"
      style={{
        height: '100vh',
        paddingTop: offsets.top + 70,
      }}
    >
      {/* Sticky Header */}
      <StickyHeaderNavigation
        title={t('translation:goal.setAGoal')}
        onBackPress={() => navigate(-1)}
      />

      <BaseView flex={1} className="flex flex-col h-full" px={13}>
        {/* Central area with amount display */}
        <BaseView
          align="center"
          gap={14}
          className="flex-1 flex flex-col justify-start"
          style={
            {
              // paddingTop: 28,
            }
          }
        >
          <BaseView gap={20} center>
            <SetGoalAmountDisplay />
            <SetGoalConversionRelative />
          </BaseView>
        </BaseView>

        {/* Bottom area with keyboard and button */}
        <BaseView
          className="flex-shrink-0"
          style={{
            gap: 12,
          }}
        >
          <SetGoalNumberPad />
          <div style={{ paddingBottom: offsets.bottom }}>
            <SetGoalButtonConfirmation />
          </div>
        </BaseView>
      </BaseView>
    </BaseView>
  )
}
